import { catalogs } from "@desfecha/i18n";
import { ApiError } from "./client";
import { locale, t, type MessageKey } from "../i18n";

/** The member-facing text of an error code; generic text for unknown codes. */
export function errorCodeText(code: string): string {
  const key = `errors.${code}` as MessageKey;
  return key in catalogs[locale.value] ? t(key) : t("common.error");
}

/** "Seu plano permite 3 números…": the limit that was reached, in the member's words. */
function planLimitText(details: unknown): string {
  const d = (details ?? {}) as { limit?: string; max?: number };
  const key = `plan.limit.${d.limit ?? ""}` as MessageKey;
  const what =
    key in catalogs[locale.value]
      ? t(key, { count: d.max ?? 0, max: d.max ?? 0 })
      : t("common.error");
  return t("errors.plan_limit", { what });
}

/**
 * "Confira o campo “Capacidade por pessoa”": a refused form names the first field the member
 * would recognize (`field.<the API's name>`), else asks to check the fields.
 */
function validationText(details: unknown): string {
  const named = Object.keys((details ?? {}) as Record<string, unknown>)
    .map((f) => `field.${f}` as MessageKey)
    .find((k) => k in catalogs[locale.value]);
  return named
    ? t("errors.validation_field", { field: t(named) })
    : t("errors.validation_failed");
}

/** What a failed API call means for the member, from the error code; generic text for unknown codes. */
export function errorText(err: unknown): string {
  if (err instanceof ApiError && err.code === "plan_limit")
    return planLimitText(err.details);
  if (err instanceof ApiError && err.code === "validation_failed")
    return validationText(err.details);
  return err instanceof ApiError ? errorCodeText(err.code) : t("common.error");
}
